/* eslint-disable */
import * as types from './action_types';
import Immutable from 'immutable';
import { ServiceError } from '../../services/service_base';

export const initialState = Immutable.fromJS({
  slug: undefined,
  followedAt: undefined,
  name: undefined,
  headline: undefined,
  createdAt: undefined,
  activeTacks: [],
  finishedTacks: [],
  loading: false,
  followLoading: false,
  followersCount: 0,
  followsCount: 0,
  error: undefined
});

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.PROFILE_FOLLOWING:
      return state.merge({ followLoading: true });
    case types.PROFILE_FOLLOWED:
      return state.merge({ followLoading: false, followedAt: action.followedAt });
    case types.PROFILE_UNFOLLOWING:
      return state.merge({ followLoading: true });
    case types.PROFILE_UNFOLLOWED:
      return state.merge({ followLoading: false, followedAt: undefined });
    case types.PROFILE_LOADING:
      return state.merge({ loading: true });
    case types.PROFILE_LOADED:
      return state.merge({ ...action.profile, loading: false });
    case types.PROFILE_ERROR:
      const error = (action.error instanceof ServiceError) ? action.error.message : action.error;
      return state.merge({ error: error, loading: false });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/stores/profile/reducer.js